"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.data = {};
    }
    MemoryStorage.prototype.getItem = function (key) {
        return this.data[key];
    };
    MemoryStorage.prototype.setItem = function (key, value) {
        var stored = typeof value === 'string' ? value : JSON.stringify(value);
        this.data[key] = stored;
    };
    MemoryStorage.prototype.removeItem = function (key) {
        delete this.data[key];
    };
    MemoryStorage.prototype.clear = function () {
        this.data = {};
    };
    Object.defineProperty(MemoryStorage.prototype, "length", {
        get: function () {
            return Object.keys(this.data).length;
        },
        enumerable: true,
        configurable: true
    });
    MemoryStorage.prototype.key = function (n) {
        if (n > this.length) {
            return null;
        }
        return Object.keys(this.data)[n];
    };
    return MemoryStorage;
}());
exports.MemoryStorage = MemoryStorage;
